module.exports = __webpack_public_path__ + "static/media/mila.6776d266.jpg";